import AddressDetails from "../Components/MyAccountTabs/AddressDetails"
import HeroSlider from "../Components/HeroSlider"
import Tabs from "../Components/Tabs"
import CreateAccount from "../Pages/CreateAccount"
import Login from "../Pages/Login"
import MyAddress from "../Pages/MyAccount/MyAddress"
import MyDashboard from "../Pages/MyAccount/MyDashboard"
import MyOders from "../Pages/MyAccount/MyOders"
import MyTrackOrders from "../Pages/MyAccount/MyTrackOrders"
import MyAccountDetails from "../Pages/MyAccount/MyAccountDetails"
import AllProductsList from "../Components/AllProductsList"
import CheckOut from "../Pages/CheckOut"
import ProductDetails from "../Pages/ProductDetails"
import Page404 from "../Pages/Page404/Page404"


const routes = [
    { path: "/", element: <HeroSlider /> },
    { path: "/AllProductsList/:category_id", element: <AllProductsList /> },
    { path: "/Login", element: <Login /> },
    { path: "/CreateAccount", element: <CreateAccount /> },
    { path: "/AddressDetails/:customer_address_id", element: <AddressDetails /> },
    { path: "/AddressDetails", element: <AddressDetails /> },
    { path: "/Tabs", element: <Tabs /> },
    { path: "/MyAccount", element: <MyDashboard /> },
    { path: "/MyOrders", element: <MyOders /> },
    { path: "/MyAddress", element: <MyAddress /> },
    { path: "/MyTrackOrders", element: <MyTrackOrders /> },
    { path: "/MyAccountDetails", element: <MyAccountDetails /> },
    { path: "/CheckOut", element: <CheckOut /> },
    { path: '/ProductDetails/:product_id', element: <ProductDetails /> },
    { path: '*', element: <Page404 /> },
]

export default routes